// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__38hzq","errors":"Errors_errors__1uq3c"};